import { render, staticRenderFns } from "./UserappRoles.vue?vue&type=template&id=100b0156&scoped=true&"
import script from "./UserappRoles.vue?vue&type=script&lang=js&"
export * from "./UserappRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b0156",
  null
  
)

export default component.exports